// UserMyAccountTemplateコンポーネントをインポート
// ユーザー向けの「Myアカウント」ページ用テンプレートとして使用
import UserMyAccountTemplate from "../templates/UserMyAccountTemplate";

/**
 * UserMyAccountPageコンポーネント
 * ユーザー向けの「Myアカウント」ページを表示するためのコンポーネント
 * UserMyAccountTemplateを利用して、アカウント情報画面を構築
 */
const UserMyAccountPage = () => {

    // Myアカウントページテンプレートをレンダリング
    // 特別なプロパティを渡さず、UserMyAccountTemplateをそのまま利用
    return (
        <UserMyAccountTemplate />
    );
}

// UserMyAccountPageコンポーネントをデフォルトエクスポート
// 他のファイルからこのコンポーネントをインポートして利用可能にする
export default UserMyAccountPage;
